export const convertMetersToMillimeters = (number: number): number => {
  return number * 1000;
};
